<style lang="css" scoped="">

</style>
<template lang="html">
  <div class="container-fluid">
  <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <div>
      <div class="card">
        <div class="card-header"> Emailer Dashboard </div>
        <div class="card-body">
          <div class="row">
             <div class="col-6 col-lg-2">
                <b-card no-block>
                  <div class="h5 text-danger text-center mb-0 mt-2">
                    <router-link style="color:#3c8289" :class="[{'click-not-allowed':emailStatus.Allocated<=0}, 'text-danger']"
                      target="_self" title="Allocated Cases"
                      :to="{ path: '/emailtracking', query: { status:'Allocated'}}">
                      {{emailStatus.Allocated}}
                    </router-link>
                  </div>
                  <div class="h6 text-danger text-center mb-0 mt-2">Allocated</div>
                  <div class="text-muted font-weight-bold text-center font-xs"><small>(As Of Now)</small></div>
                </b-card>
              </div><!--/.col-->

              <div class="col-6 col-lg-2">
                <b-card no-block>
                  <div class="h5 text-primary text-center mb-0 mt-2">
                     <router-link style="color:#fea223" class="" target="_self"
                      :class="[{'click-not-allowed':emailStatus.InProcess<=0},'text-primary']" title="InProcess Cases"
                      :to="{ path: '/emailtracking', query: { status:'InProcess'}}">
                      {{emailStatus.InProcess}}
                    </router-link>
                  </div>
                  <div class="h6 text-primary text-center mb-0 mt-2">InProcess</div>
                  <div class="text-muted font-weight-bold text-center font-xs"><small>(As Of Now)</small></div>
                </b-card>
              </div><!--/.col-->

              <div class="col-6 col-lg-2">
                <b-card no-block>
                  <div class="h5 text-success text-center mb-0 mt-2">
                     <router-link style="color:#86ad47" class="" target="_self"
                      :class="[{'click-not-allowed':emailStatus.Close<=0}, 'text-success']" title="Closed Cases"
                      :to="{ path: '/emailtracking', query: { status:'Close'}}">
                      {{emailStatus.Close}}
                    </router-link>
                  </div>
                  <div class="h6 text-success text-center mb-0 mt-2">Closed</div>
                  <div class="text-muted font-weight-bold text-center font-xs"><small>(Today)</small></div>
                </b-card>
              </div><!--/.col-->

              <div class="col-6 col-lg-2">
                <b-card no-block>
                  <div class="h5 text-secondary text-center mb-0 mt-2">
                    <router-link style="color:#e04b4a" class="" target="_self"
                      :class="[{'click-not-allowed':emailStatus.Spam<=0}, 'text-secondary']" title="Spam Cases"
                      :to="{ path: '/emailtracking', query: { status:'Spam'}}">
                      {{emailStatus.Spam}}
                    </router-link>
                  </div>
                  <div class="h6 text-secondary text-center mb-0 mt-2">Spam</div>
                  <div class="text-muted font-weight-bold text-center font-xs"><small>(Today)</small></div>
                </b-card>
              </div><!--/.col-->
               <div class="col-6 col-lg-2">
                <b-card no-block>
                     <div class="h5 text-primary text-center mb-0 mt-2">
                       <router-link target="_self" title="Follow Up Cases" class="has-text-black-bis" :class="[{'click-not-allowed':emailStatus.FollowUp<=0}, 'text-primary' ]"
                        :to="{ path: '/emailtracking', query: { status:'followup',tlemail:filter.tlemailid}}">
                            {{emailStatus.FollowUp}}
                        </router-link>
                    </div>
                    <div class="h6 text-primary text-center mb-0 mt-2">Follow Up</div>
                    <div class="text-muted text-center font-weight-bold font-xs"><small>(Today)</small></div>
                </b-card>
              </div><!--/.col-->
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
  import apiUrl from '../../../constants'
  import axios from 'axios'
  //import CONSTANTS from '@/utils/constants'
  //import stores from '@/stores'
  import commonFunction from '../../../commonFunction'
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css'

  export default {
    name: 'agentdashboard',
     components: {
      Loading
    },
    data: function () {
      return {
        emailStatus: {
          Allocated: 0,
          InProcess: 0,
          Close: 0,
          Spam: 0,
          FollowUp: 0
        },
        ivr: {
          outcallcount: 0,
          shortbrk: '00:00:00',
          longbrk: '00:00:00',
          breaktime: '00:00:00',
          logisticsSentEmail: 0
        },
        agentEmail: '',
        designation: '',
        userDetails: {},
        isLoading: false,
        subDepartmentList: [],
        filter: {
          subdepartmentid: ''
        },
        fullPage: false,
      }
    },
    created() {
      /*let perm = stores.user.hasPermission('/emailr/agentdashboard', 'Read')
      if (!perm) {
        this.$router.push({
          path: '/'
        })
        return this.$buefy.toast.open({
          message: 'You do not have access to this page.',
          type: 'is-danger'isrepeatcount
        })
      } else {
        this.userDetails = stores.user.getLoggedinUserData()
        if (this.userDetails.subdepartment.length && this.userDetails.subdepartment[0].subdepartmentid) {
          this.subDepartmentList = this.userDetails.subdepartment.filter((m) => {
            if ((m.subdeptname) && (m.subdeptname.toLowerCase() === 'ccemail' || m.subdeptname.toLowerCase() === 'babyhugemail')) {
              this.filter.subdepartmentid = m.subdepartmentid
              return m
            }
          })
        }
        this.agentEmail = this.userDetails.emailaddress
        this.emailsStatusCount()
        this.IVRDetails()
      }
      */
      [this.subDepartmentList, this.DepartmentID, this.userdetail, this.permissiondata, this.userTypeForTicket, this
        .SummarySelectOptionObj, this.SummaryOptionObj
      ] = commonFunction.getuserDetailsAndpermissionData();
      // console.log( 'userdetail : '+JSON.stringify( this.userdetail ) );
      this.subDepartmentList = this.subDepartmentList.filter(function (dept) {
          return dept.text == "Outbound Call Center" || dept.text == "Inbound Call Center";
      });
      this.agentEmail = this.userdetail[0].email.toLowerCase();
      //  console.log( 'agentEmail : '+ this.agentEmail);
      this.filter.subdepartmentid = this.DepartmentID;
      this.emailsStatusCount();
    },

    mounted (){


    },

    methods: {
      reloadData: function () {
        this.isLoading = true
        this.emailsStatusCount()
        // this.IVRDetails()
      },
      emailsStatusCount: function () {
        // console.log("this.filter.subdepartmentid(AGENT)---------------------------------------------FRONTEND","--",this.agentEmail,"--");
        let statusCount = {
         subdepartmentid: this.filter.subdepartmentid,
          role: 'agent',
          // role: 'Associate',
          assignedto: this.agentEmail
        }
        // console.log("statusCount------------",statusCount);
          this.isLoading = true;
       return axios({
          'method': 'POST',
          'url': apiUrl.api_url + 'fetchcasestatuscount',
          headers: commonFunction.getusertoken(),
          'data': statusCount
        })
        .then((result) => {

            this.isLoading = false
            if (result) {
              // console.log( 'result :--------------------------------------'+JSON.stringify(result));
              this.emailStatus.AllocationPending = result.data.allocationpending || 0
              this.emailStatus.Allocated = result.data.allocated || 0
              this.emailStatus.InProcess = result.data.inprocess || 0
              this.emailStatus.Close = result.data.close || 0
              this.emailStatus.Spam = result.data.spam || 0
              this.emailStatus.Trash = result.data.trash || 0
              this.emailStatus.FollowUp = result.data.followup || 0
            }
          }).catch((error) => {
            this.isLoading = false
            return this.$buefy.toast.open({
              message: error.message,
              type: 'is-danger'
            })
          })
      },
      IVRDetails: function () {
        return http.post(`${CONSTANTS.API_URL}/api/ivr/getagentwisebreakdetails`, {
            emails: this.userDetails.emailaddress,
            location: this.userDetails.location || ''
          })
          .then((ivrApiResult) => {
            this.isLoading = false
            if (ivrApiResult && ivrApiResult.length) {
              this.ivr.outcallcount = ivrApiResult[0].outcallcount || 0
              this.ivr.shortbrk = ivrApiResult[0].shortbrk || '00.00.00'
              this.ivr.longbrk = ivrApiResult[0].longbrk || '00.00.00'
              this.ivr.breaktime = ivrApiResult[0].breaktime || '00.00.00'
            }
          })
          .catch((httpException) => {
            this.isLoading = false
            return this.$buefy.toast.open({
              message: httpException.message,
              type: 'is-danger'
            })
          })
      }
    }
  }
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/views/components/emailr/agentdashboard.vue?0124dada